import styled, { css } from 'styled-components';

import UI from './UI';

const PopularEventLabel = styled(UI.Label)`
  ${({ theme }) => css`
    background: ${theme.transparentize(theme.colors.white, 0.3)};
    border: 1px solid ${theme.transparentize(theme.colors.white, 0.5)};
    color: ${theme.colors.gray[800]};
    box-shadow: ${theme.shadows.sm};
    font-weight: 500;
    backdrop-filter: blur(3px);
  `}
`;

export default PopularEventLabel;
